export enum AccountActionType {
    DoctorAccountCreation = "doctorAccount",
    DoctorAccountEdition = "update",
    DoctorAccountFilled = "prefilled",

    PatientAccountCreation = "patientAccountCreation",
    PatientAccountEdition = "patientAccountEdition",
}
